import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Logo from '../../assets/logo2.png';
import { useAuth0 } from '@auth0/auth0-react';
import AppConfig from '../../config';

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {AppConfig.AppVersion}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: '#349CC9',
        color: 'white',
        minWidth: 120
    },
}));

export default function SignIn() {
    const classes = useStyles();
    const { loginWithRedirect } = useAuth0();

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <img src={Logo} style={{ width: 400, marginTop: 60, marginBottom: 80 }} />
                {/* <Typography component="h1" variant="h5">
                    Sign in
                </Typography> */}
                <form className={classes.form} noValidate>
                    <Box textAlign='center'>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={() => loginWithRedirect()}
                    >
                        Log In
                    </Button>
                    </Box>
                    
                </form>
            </div>
            <Box mt={8} style= {{marginTop: 300}}>
                <Copyright />
            </Box>
        </Container>
    );
}